import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Story } from '../../models/story';
import { withStorySelectors } from './story.selectors';
import { StoryService } from '../../services/story/story.service';
import { inject } from '@angular/core';
import { ActiveUserStore } from '../user/active-user.state';
import { withLogging } from '../features/logger.feature';
import { loadWhen } from '../features/load-when';
import { ConfirmationDialogService } from '../../services/confirmation-dialog.service';

export type StoryState = BaseState<Story>;

export const initialState: StoryState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Story',
  entityLabel: 'Bericht',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const StoryStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Story>(StoryService),
  withLogging(initialState.entityType),
  withStorySelectors(),
  withMethods(
    (
      store,
      storyService = inject(StoryService),
      confirmationDialogService = inject(ConfirmationDialogService)
    ) => ({
      /**
       * fill pool state with pool-indicators
       */
      async findByCategoryIds(categoryIds: string[]) {
        patchState(store, { loading: true });

        try {
          const items = await storyService.getByCategoryIds(categoryIds);
          patchState(store, {
            items: items,
            loading: false,
            initialized: true,
            itemsLoaded: true,
          });
        } catch (error) {
          patchState(store, { loading: false, initialized: true, error });
          confirmationDialogService.addErrorMessage(
            `${store.entityLabel()} konnten nicht geladen werden.`,
            'Daten konnten nicht geladen werden'
          );
        }
      },
    })
  ),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // Same early-construction issue as BookmarkStore (see there for the
      // full explanation): TopicHelperService field-injects this store
      // directly, pre-login, so a one-shot permission check here always
      // saw a null user and never loaded. Watch reactively instead.
      loadWhen(
        () =>
          activeUserStore.canSeeAllInWorkspaceType('bookmarkCategory') &&
          activeUserStore.commune(),
        () => store.loadAllItemsByPromise()
      );
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
